export class PortalConstants {
  static elementId = 'modal-portal-target';
}
